export class SlideNotifier{
    bg: string;
    gif: string;
    caption: string;

    constructor(bg:string, gif: string, caption: string){
        this.bg = bg;
        this.gif = gif;
        this.caption = caption;
    }
}


// WEBPACK FOOTER //
// ./src/app/models/slideNotifier.model.ts